export default __webpack_public_path__ + "search-gray.svg?81ffd43d88918981b23f218bb0cf25cc";